<template>
  <SaleOrderForm orderType="Pickup" :editMode="false" />
</template>
<script>
import SaleOrderForm from "@/components/ModuleBasedComponents/Order/SaleOrder/SaleOrderForm.vue";
export default {
  components: {
    SaleOrderForm,
  },
};
</script>
